import type { FaireProductEntity } from "../../entity_types/product";

export const p_tx49cgm955: FaireProductEntity = {
  token: "p_tx49cgm955",
  type: "product",
  name: "I ❤️ Pickles Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/b9c60d795e717c35ee6804abb18b8dacf669b25bda4f7b63f75c3b296b7255e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca2d92a38a412e17294e3fbf6d2756afe18aab2b01d6c70dc9c7422530784927.jpeg",
    "https://cdn.faire.com/fastly/c07fb1f5d0851a01ba0e1eca243304adc9b15ee5047f379e7cc5402965f95c69.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/34bf90340eab9a56ffa097b3341412e392dfcb55af6c7ea7441a3d754725bcb9.jpeg",
    "https://cdn.faire.com/fastly/90ad66ee08da2fd67a2b75fd0d840680c6da1f07ec1864701e2e8eedd746d874.jpeg"
  ],
  priceDollars: 6.75,
  description: "Salty... Crunchy... Tangy... Wet... 🤤 Have 'em on a hotdog, burger, fried, or fresh out the jar... there's no wrong way to live that #picklelife 🥒 🫶\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:52.461Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
